$(document).ready(function () {
    setTimeout(function () {
        $('.products .box.product, .product-container .box.product').each(function () {
            let thisProduct = $(this);

            let productHandle = thisProduct.data('handle');

            if (typeof productHandle != 'undefined' && productHandle != '') {
                $.getJSON('/products/' + productHandle + '.js', function (product) {
                    let images = product.images;

                    thisProduct.find('.quick-view-cart-box .qv-product-options .sizeSectionProduct').html('');

                    let colourOptionValues = '';
                    let initialColor = '';
                    $(product.options).each(function (i, option) {
                        let opt = option.name;
                        let optLower = opt.toLowerCase();

                        if (optLower == 'color') {
                            let imgUrl = '';
                            let valI = 0;

                            $(option.values).each(function (i, value) {
                                let imgUrl = images[valI] ? images[valI] : imgUrl;

                                let camelValue = value.toLowerCase().replace(' ', '-');
                                camelValue = camelValue.replace(' ', '-');
                                camelValue = camelValue.replace(' ', '-');
                                camelValue = camelValue.replace(' ', '-');

                                colourOptionValues += '<div class="swatch-container ' + optLower + ' circle" data-image-src="' + imgUrl + '">' +
                                    '<input type="radio" ' + (valI == 0 ? 'checked="checked"' : '') + ' value="' + value + '" name="colour_options_product_' + product.id + '_' + optLower + '" class="single-option-selector__radio single-option-selector-product-template" id="colour_options_product_radio_select_option_' + product.id + '_' + optLower + '_' + value + '">' +
                                    '<label class="swatch-label--color" for="colour_options_product_radio_select_option_' + product.id + '_' + optLower + '_' + value + '" style="background-image: url(//cdn.shopify.com/s/files/1/0573/0598/9296/t/17/assets/' + (camelValue) + '_80x.png);">' +
                                    '<span class="swatch--swatch lazyloading bg-' + camelValue + '" style="background-color:initial;"></span>' +
                                    '<span class="swatch--text">' + value + '</span>' +
                                    '</label>' +
                                    '</div>';

                                initialColor = value;

                                valI += 1;
                            });
                        }

                        let optionValues = '';
                        let optionValI = 0;
                        let checkedAlready = 'no';
                        $(option.values).each(function (i, value) {
                            let camelValue = value.toLowerCase().replace(' ', '-');
                            camelValue = camelValue.replace(' ', '-');
                            camelValue = camelValue.replace(' ', '-');
                            camelValue = camelValue.replace(' ', '-');

                            let isAvailable = 'no';
                            if (optLower != 'color') {
                                let combination = initialColor + ' / ' + value;

                                $(product.variants).each(function (i, variant) {
                                    if (variant.title.trim() == combination.trim()) {
                                        if (variant.available == true) {
                                            isAvailable = 'yes';
                                        }
                                    }
                                });
                            } else {
                                isAvailable = 'yes';
                            }

                            optionValues += '<div class="swatch-container ' + optLower + ' ' + (optLower == 'color' ? 'circle' : '') + (optLower != 'color' && isAvailable == 'soldout' ? 'disabled' : '') + '">' +
                                '<input type="radio" ' + (checkedAlready == 'no' && isAvailable == 'yes' ? 'checked="checked"' : '') + ' ' + (optLower != 'color' && isAvailable == 'no' ? 'disabled' : '') + ' value="' + value + '" name="product_' + product.id + '_' + optLower + '" class="single-option-selector__radio single-option-selector-product-template" id="product_radio_select_option_' + product.id + '_' + optLower + '_' + value + '">' +
                                '<label for="product_radio_select_option_' + product.id + '_' + optLower + '_' + value + '" title="' + value + '" class="' + (optLower == 'color' ? 'swatch-label--color' : '') + '" style="background-image: url(//cdn.shopify.com/s/files/1/0573/0598/9296/t/17/assets/' + (camelValue) + '_80x.png);">' +
                                (optLower == 'color' ? '<span class="swatch--swatch lazyloading bg-' + camelValue + '" style="background-color:initial;"></span>' : '') +
                                '<span class="swatch--text">' + value + '</span>' +
                                '</label>' +
                                '</div>';


                            if (optLower != 'color' && checkedAlready == 'no') {
                                checkedAlready = isAvailable;
                            }

                            optionValI = parseInt(optionValI) + 1;
                        });

                        setTimeout(function () {
                            thisProduct.find('.sizeSectionProduct').append('<div class="radio-wrapper js product-form__item variation__item">' +
                                '<label class="single-option-radio__label swatchSec">' + opt + '' +
                                (optLower == 'color' ? '<span class="single-option-radio__label--value label-extra"></span>' : '') +
                                '</label>' +
                                '<fieldset class="single-option-radio" name="product_' + optLower + '">' + optionValues + '</fieldset>' +
                                '</div>');
                        }, 500);
                    });

                    setTimeout(function () {
                        thisProduct.find('.productColourOptions').html('<div class="sizeSectionProduct">' +
                            '<div class="radio-wrapper js product-form__item variation__item">' +
                            '<fieldset class="single-option-radio">' + colourOptionValues + '</fieldset>' +
                            '</div>' +
                            '</div>');
                    }, 500);
                });

                setTimeout(function () {
                    let productSwatch = thisProduct.find('.swatch-container');
                    if (productSwatch.hasClass('color')) {
                        thisProduct.find('.single-option-radio__label--value').text(productSwatch.find('input:checked').val());
                    }
                }, 500);
            } else {
                console.log('Product handler not found!');
            }
        });

        $('.quick-view-cart-box .single-option-radio').each(function () {
            let productDiv = $(this).parents('.product');
            let productSwatch = $(this).parents('.swatch-container');
            if (productSwatch.hasClass('color')) {
                productDiv.find('.quick-view-cart-box .single-option-radio__label--value').text(productSwatch.find('input:checked').val());
            }
        });

        $('.qvProductCarousel').flickity({
            imagesLoaded: true,
            percentPosition: false,
        });

        setTimeout(function () {
            generateCombinationId();
        }, 1000);

    }, 1000);
});

$(document).on("change", ".productColourOptions input", function () {
    let productDiv = $(this).parents('.product');
    let productImage = $(this).parents('.swatch-container').attr('data-image-src');

    if (productImage != '') {
        productDiv.find('.product_card__image').attr('src', productImage);
        productDiv.find('.product_card__image').attr('srcset', productImage);
    }
});

$(document).on("change", ".quick-view-cart-box.open input, .styleProduct .sizeSectionProduct input", function () {
    let productDiv = $(this).parents('.product');
    let productSwatch = $(this).parents('.swatch-container');
    let noOfSelectedItem = 0;

    let noOfVariants = 0;
    let productHandle = productDiv.data('handle');
    ;
    if (productDiv.hasClass('styleProduct')) {
        noOfVariants = productDiv.find('.single-option-radio').length;
    } else {
        noOfVariants = productDiv.find('.quick-view-cart-box .single-option-radio').length;
    }

    if (productSwatch.hasClass('color')) {
        productDiv.find('.single-option-radio__label--value').text(productSwatch.find('input:checked').val());
    }

    let combination = '';
    if (productDiv.hasClass('styleProduct')) {
        productDiv.find('.swatch-container').each(function () {
            let thisRadioItem = $(this);
            if (thisRadioItem.find('input:checked').length > 0) {
                let selectedOption = thisRadioItem.find('input:checked').val();

                noOfSelectedItem = parseInt(noOfSelectedItem) + 1;

                if (combination != '') {
                    combination = combination + ' / ' + selectedOption;
                } else {
                    combination = selectedOption;
                }
            }
        });
    } else {
        productDiv.find('.quick-view-cart-box .variation__item .single-option-radio .swatch-container').each(function () {
            let thisRadioItem = $(this);
            if (thisRadioItem.find('input:checked').length > 0) {
                let selectedOption = thisRadioItem.find('input:checked').val();

                noOfSelectedItem = parseInt(noOfSelectedItem) + 1;

                if (combination != '') {
                    combination = combination + ' / ' + selectedOption;
                } else {
                    combination = selectedOption;
                }
            }
        });
    }

    if (noOfVariants == noOfSelectedItem) {
        processVariantCombination(combination, productDiv, productHandle);
    }
});

$(document).on('click', '.quick-view', function () {
    $('.quick-view-cart-box').removeClass('open');

    let productDiv = jQuery(this).parents('.product');
    productDiv.find('.quick-view-cart-box').addClass('open');

    let combinationID = productDiv.find('.btnAddToCart').attr('.data-variation-id');
    if (typeof combinationID == 'undefined' || combinationID == '') {
        let productHandle = productDiv.data('handle');
        let noOfVariants = productDiv.find('.quick-view-cart-box .single-option-radio').length;
        let noOfSelectedItem = 0;

        let combination = '';
        productDiv.find('.quick-view-cart-box .variation__item .single-option-radio .swatch-container').each(function () {
            let thisRadioItem = $(this);
            if (thisRadioItem.find('input:checked').length > 0) {
                let selectedOption = thisRadioItem.find('input:checked').val();

                noOfSelectedItem = parseInt(noOfSelectedItem) + 1;

                if (combination != '') {
                    combination = combination + ' / ' + selectedOption;
                } else {
                    combination = selectedOption;
                }
            }
        });

        if (noOfVariants == noOfSelectedItem) {
            processVariantCombination(combination, productDiv, productHandle);
        }
    }
});

function generateCombinationId() {
    $('.btnAddToCart').each(function () {
        let combinationID = $(this).attr('.data-variation-id');
        if (typeof combinationID == 'undefined' || combinationID == '') {
            let productDiv = $(this).parents('.product');
            let productSwatch = $(this).parents('.swatch-container');
            let noOfSelectedItem = 0;

            let noOfVariants = 0;
            let productHandle = productDiv.data('handle');
            ;
            if (productDiv.hasClass('styleProduct')) {
                noOfVariants = productDiv.find('.single-option-radio').length;
            } else {
                noOfVariants = productDiv.find('.quick-view-cart-box .single-option-radio').length;
            }

            if (productSwatch.hasClass('color')) {
                productDiv.find('.single-option-radio__label--value').text(productSwatch.find('input:checked').val());
            }

            let combination = '';
            if (productDiv.hasClass('styleProduct')) {
                productDiv.find('.swatch-container').each(function () {
                    let thisRadioItem = $(this);
                    if (thisRadioItem.find('input:checked').length > 0) {
                        let selectedOption = thisRadioItem.find('input:checked').val();

                        noOfSelectedItem = parseInt(noOfSelectedItem) + 1;

                        if (combination != '') {
                            combination = combination + ' / ' + selectedOption;
                        } else {
                            combination = selectedOption;
                        }
                    }
                });
            } else {
                productDiv.find('.quick-view-cart-box .variation__item .single-option-radio .swatch-container').each(function () {
                    let thisRadioItem = $(this);
                    if (thisRadioItem.find('input:checked').length > 0) {
                        let selectedOption = thisRadioItem.find('input:checked').val();

                        noOfSelectedItem = parseInt(noOfSelectedItem) + 1;

                        if (combination != '') {
                            combination = combination + ' / ' + selectedOption;
                        } else {
                            combination = selectedOption;
                        }
                    }
                });
            }

            if (noOfVariants == noOfSelectedItem) {
                processVariantCombination(combination, productDiv, productHandle);
            }
        }
    });
}

function processVariantCombination(combination = '', productDiv = '', productHandle = '') {
    if (productDiv == '') {
        productDiv = $('.quick-view-cart-box.open').parents('.product');
    }

    if (productHandle == '') {
        productHandle = productDiv.data('handle');
    }

    let addToCartBtn = productDiv.find('button.btnAddToCart');
    addToCartBtn.text('Wait..');
    addToCartBtn.attr('disabled', 'disabled');

    let variationId = '';
    let variationImg = '';
    if (productHandle != '' && combination != '') {
        $.getJSON('/products/' + productHandle + '.js', function (product) {
            $(product.variants).each(function (i, variant) {
                if (variant.title.trim() == combination.trim()) {
                    if (variant.available == true) {
                        variationId = variant.id;
                        variationImg = variant.featured_image.src;
                    }
                }
            });
        });
    }

    setTimeout(function () {
        addToCartBtn.text('Add To Bag');

        if (variationImg != '') {
            productDiv.find('.product_card__image').attr('src', variationImg);
            productDiv.find('.product_card__image').attr('srcset', variationImg);
        }

        if (variationId != '') {
            addToCartBtn.removeAttr('disabled');
            addToCartBtn.attr('data-variation-id', variationId);
            productDiv.find('.qv-add-to-cart-response').html('');
        } else {
            addToCartBtn.removeAttr('data-variation-id');
            addToCartBtn.attr('disabled', 'disabled');
            productDiv.find('.qv-add-to-cart-response').addClass('error').html('Not available');
        }
    }, 2000);
}

$(document).on("click", "button.btnAddToCart", function () {
    let addToCartBtn = $(this);
    let variationId = addToCartBtn.attr('data-variation-id');

    addToCartBtn.text('Adding...');
    addToCartBtn.attr('disabled', 'disabled');

    processCart(variationId, addToCartBtn);
});

function processCart(variationId = '', addToCartBtn = '') {
    $.post('/cart/add.js', {quantity: 1, id: variationId}, null, "json").done(function () {
        addToCartBtn.text('Add To Bag');
        addToCartBtn.removeAttr('disabled');

        $('.qv-add-to-cart-response').addClass('success');
        $('.qv-add-to-cart-response').removeClass('error');
        $('.qv-add-to-cart-response').html('<span>Added Successfully</span>');

        let CartCount = $('#CartCount').text();
        CartCount = parseFloat(CartCount) + 1;
        $('#CartCount').text(CartCount);

    }).fail(function ($xhr) {
        addToCartBtn.text('Add To Bag');
        addToCartBtn.removeAttr('disabled');

        let data = $xhr.responseJSON;
        $('.qv-add-to-cart-response').addClass('error');
        $('.qv-add-to-cart-response').removeClass('success');
        $('.qv-add-to-cart-response').html('<span>' + data.description + '</span>');
    });
}

function hideQuickViewDiv() {
    $('.quick-view-cart-box.open').removeClass('open');
}